<div class="container-fluid" style="margin-top: 5% !important;" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'&&!clienteserviceParam.rolABFlag">
  <div class="card mt-1" style="width: 797px !important;">
    <span class="text-center" style="color: #de2460">
      <i class="bi bi-circle-fill mr-3 " style="font-size: 8px"></i>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteConCodigoBantrab === 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente deben ser registrados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor deben ser registrados
        </span>
      </span>
      <span class="mt-1" *ngIf="clientData.cliente.existeClienteActualizado !== 'S'
        && clientData.cliente.existeClienteConCodigoBantrab !== 'N'">
        <span *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
          Los datos del cliente se encuentran desactualizados
        </span>
        <span *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
          Los datos del codeudor se encuentran desactualizados
        </span>
      </span>
    </span>
  </div>
</div>
<div class="container-fluid">
  <h3>Ingresos</h3>
  <h4>Ingresa o actualiza tus datos.</h4>
  <div class="segmentoingreso">
    <div class="table4">
      <table class="table table-borderless">
        <tbody>
          <tr>
            <th>Ingresos Personales</th>
            <th></th>
          </tr>
          <tr>
            <td>
              <h2>Salario base</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.salarioBase" (blur)="changeIngresos($event)"
                  class="form-control"  [readonly]="cargaindicesbool && precalificationData.segmento=='E' && clienteserviceParam.manualEntry === false" name="salario">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>Bonificaciones</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.bonificaciones" (blur)="transformAmount($event)"
                  class="form-control" [readonly]="cargaindicesbool && precalificationData.segmento=='E' && clienteserviceParam.manualEntry === false" name="bonos">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>Comisiones</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.comisiones" (blur)="transformAmount($event)"
                  class="form-control" [readonly]="cargaindicesbool && precalificationData.segmento=='E' && clienteserviceParam.manualEntry === false" name="comisiones">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>Otros ingresos</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.otrosIngresos" (blur)="transformAmount($event)"
                  class="form-control"  name="otrosingresos">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="segmentoingreso">
    <div class="table4">
      <table class="table table-borderless">
        <tbody>
          <tr>
            <th>Deducciones</th>
            <th></th>
          </tr>
          <tr>
            <td>
              <h2>IGSS</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.igss" readonly (blur)="transformAmount($event)"
                  class="form-control"  name="igss">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>ISR</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.isr" readonly (blur)="transformAmount($event)"
                  class="form-control"  name="isr">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>Judiciales</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.judiciales" (blur)="transformAmount($event)"
                  class="form-control" [readonly]="cargaindicesbool && clienteserviceParam.datosPrecalificacion.segmento=='E' && clienteserviceParam.manualEntry === false" name="judiciales">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <h2>Otras Deducciones</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.otrasDeducciones" (blur)="transformAmount($event)"
                  class="form-control"  name="otrasdeducciones">
              </div>
            </td>
          </tr>
          <tr *ngIf="precalificationData.segmento=='E'">
            <td>
              <h2>Cuota Banco Índice</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.cuotaBancoIndice" readonly (blur)="transformAmount($event)"
                  class="form-control"  name="cuotaindice">
              </div>
            </td>
          </tr>
          <tr *ngIf="precalificationData.segmento=='E'">
            <td>
              <h2>Salario Líquido BT</h2>
            </td>
            <td>
              <div class="input-group mb-3" style="margin-bottom: 0 !important;">
                <div class="input-group-prepend">
                  <span class="input-group-text">Q</span>
                </div>
                <input type="text" [(ngModel)]="ingresosydeducciones.salarioLiquidoBT" readonly (blur)="transformAmount($event)"
                  class="form-control"  name="liquidobt">
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div style="text-align: left;">
        <button class="btn round-button-back" (click)="goBack()">Regresar</button>
      </div>
    </div>
    <div class="col-md-6">
      <div style="text-align: right;">
        <button class="btn round-button" (click)="goToConsolidar()">Continuar</button>
      </div>
    </div>
  </div>
</div>
